module.exports = __webpack_public_path__ + "img/logo-black.63c2234f.png";